<template>
  <div>
    <el-header class="layout-header" height="88px" style="padding-left: 0;">
      <div class="flex-sb" style="align-items: center;">
        <div class="flex">
          <div>
            <img src="@/assets/u45.png" class="img-size">
          </div>
          <div style="padding-left: 10px; padding-top: 10px;">
            <div class="title-top">
              <span>清单单价清册管理系统</span>
            </div>
            <div class="title-bottom">
              <span>上海市房地产估价师协会</span>
            </div>
          </div>
        </div>
        <div>
          <el-dropdown @command="dropDownClick" class="name-hover">
            <div class="flex" style="align-items: center;">
              <img src="@/assets/u46.png" class="icon-size">
              <span class="name">&nbsp;&nbsp;&nbsp;{{userName}}</span>
              <i class="el-icon-arrow-down" style="color: #FFFFFF;"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="resetPassword">修改密码</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </el-header>
    <el-dialog title="修改密码" :visible.sync="resetPasswordDialogShow" @close="cancelButtonClick">
      <el-form ref="resetPasswordForm" :model="resetPasswordForm" label-width="100px" :rules="resetPasswordRules">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input v-model="resetPasswordForm.oldPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input v-model="resetPasswordForm.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input v-model="resetPasswordForm.confirmPassword" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="changeButtonClick">确 定</el-button>
        <el-button @click="cancelButtonClick">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import cookie from '../util/cookie.js'
import { storage, clean } from '../util/'

export default {
  data () {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.resetPasswordForm.confirmPassword !== '') {
          this.$refs.resetPasswordForm.validateField('confirmPassword')
        }
        callback()
      }
    }
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.resetPasswordForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      resetPasswordDialogShow: false,
      resetPasswordForm: {
        oldPassword: '',
        password: '',
        confirmPassword: ''
      },
      resetPasswordRules: {
        password: [
          { validator: validatePass, trigger: 'blur', required: true },
          { min: 6, message: '密码长度不能小于6', trigger: 'blur' }
        ],
        confirmPassword: [
          { validator: validatePass2, trigger: 'blur', required: true },
          { min: 6, message: '密码长度不能小于6', trigger: 'blur' }
        ],
        oldPassword: [
          { trigger: 'blur', required: true, message: '请输入原密码' },
          { min: 6, message: '密码长度不能小于6', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    userName () {
      return storage('name')
    }
  },
  methods: {
    changeButtonClick () {
      this.$refs['resetPasswordForm'].validate((valid) => {
        if (valid) {
          this.changePassword()
        }
      })
    },
    async changePassword () {
      let response = await this.$http.post('/user/changePwd', this.resetPasswordForm)
      const responseData = response.data
      if (Number.parseInt(responseData.ret) === 1) {
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.resetPasswordDialogShow = false
      } else {
        this.$message.error(responseData.msg)
      }
    },
    cancelButtonClick () {
      this.resetPasswordDialogShow = false
      this.$refs['resetPasswordForm'].resetFields()
    },
    showChangePasswordModal () {
      this.resetPasswordDialogShow = true
    },
    logout () {
      clean()
      this.$router.push({ name: 'login' })
      this.$oneitfarm.setToken('')
      this.$oneitfarm.setChannel('')
      cookie.removeItem('autoLogin')
    },
    dropDownClick (command) {
      switch (command) {
        case 'resetPassword': {
          this.showChangePasswordModal()
          break
        }
        case 'logout': {
          this.logout()
          break
        }
      }
    }
  }
}
</script>
<style scoped>
.layout-header {
  background-image: url('../assets/u42.png');
}
.img-size {
  /* width: 60px; */
  height: 88px;
}
.title-top {
  height: 50px;
  line-height: 50px;
  font-family: 'PingFangSC-Regular', 'PingFang SC';
  font-weight: 400;
  font-style: normal;
  font-size: 36px;
  color: #FFFFFF;
}
.title-bottom {
  line-height: normal;
  height: 18px;
  font-family: 'STXinwei';
  font-weight: 400;
  font-style: normal;
  font-size: 18px;
  color: #FFFFFF;
}
.name-hover:hover {
  cursor: pointer;
}
.icon-size {
  height: 24px;
  width: 24px;
}
.name {
  font-family: 'MicrosoftYaHei', 'Microsoft YaHei';
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  color: #FFFFFF;
}
</style>
